<template>
  <div>
    <vx-tooltip text="Editar" color="primary" position="left">
      <feather-icon
        icon="EditIcon"
        svgClasses="hover:text-primary stroke-current mt-1 pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-prompt
      :title="title + ' ' + item.id"
      accept-text="Salvar"
      cancel-text="Cancelar"
      button-cancel="border"
      @cancel="cancel"
      @accept="save"
      @close="cancel"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-input
                class="w-full my-2"
                label="Nome"
                v-model="item.nome"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-full">
              <vs-input
                class="w-full my-2"
                label="E-mail"
                v-model="item.email"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2">
              <vs-input
                class="w-full my-2"
                label="CPF"
                v-model="item.cpf"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2">
              <vs-input
                class="w-full my-2"
                label="RG/RNE"
                v-model="item.documento"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2">
              <span class="vs-input--label">Perfil</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_perfil"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in perfis"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2">
              <span class="vs-input--label">Setor</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_setor"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in setores"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!--div class="vx-col w-1/2">
              <span class="vs-input--label">Foto</span>
              <el-upload
                class="avatar-uploader"
                action
                accept=".jpg, .jpeg, .png"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="onChange"
              >
                <img v-if="pic" :src="pic" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </!--div-->
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    itemCopy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      item: {},
      perfis: [],
      setores: [],
    };
  },
  computed: {
    validateForm() {
      return (
        this.item.nome !== "" &&
        this.item.id_setor > 0 &&
        this.item.id_perfil > 0
      );
    },
  },

  methods: {
    async open() {
      this.item = { ...this.itemCopy };
      this.activePrompt = true;
      await Promise.all([
        this.getPerfis(),
        this.getSetores(),
      ])
    },
    async saveData() {
      await this.$vs.loading();
      try {
        this.rows = await this.$http.put(
          `${this.url}/${this.item.id}`,
          this.item
        );
        this.$vs.notify(this.$notify.Success);
        this.$emit("done");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async save() {
      if (this.validateForm) {
        await this.saveData();
      }
    },
    async cancel() {},
    async getPerfis(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.perfis = await this.$http.get(`perfil`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getSetores(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.setores = await this.$http.get(`setor`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
  },
  async mounted() {},
};
</script>
